var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPuzzelRightHalfCir(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 204.5 208",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4a4849;}.cls-2{fill:#f2b770;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M204.5,5V206a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V143.44a2,2,0,0,1,1.88-2A36,36,0,0,0,36,105.5,36,36,0,0,0,1.88,69.55a2,2,0,0,1-1.88-2V5A2,2,0,0,1,2,3H202.5A2,2,0,0,1,204.5,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M204,5.5v200a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V143.44a2,2,0,0,1,1.88-2A36,36,0,0,0,36,105.5,36,36,0,0,0,1.88,69.55a2,2,0,0,1-1.88-2V5.5a2,2,0,0,1,2-2H202A2,2,0,0,1,204,5.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3-2",
    "data-name": "Rectangle 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M204.5,2V203a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V140.44a2,2,0,0,1,1.88-2A36,36,0,0,0,36,102.5,36,36,0,0,0,1.88,66.55a2,2,0,0,1-1.88-2V2A2,2,0,0,1,2,0H202.5A2,2,0,0,1,204.5,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M204,2.5v200a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V140.44a2,2,0,0,1,1.88-2A36,36,0,0,0,36,102.5,36,36,0,0,0,1.88,66.55a2,2,0,0,1-1.88-2V2.5a2,2,0,0,1,2-2H202A2,2,0,0,1,204,2.5Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuzzelRightHalfCir);
export default __webpack_public_path__ + "static/media/Puzzel_Right_HalfCir.8acc2125046be7757aaf9ecfed0b8bd6.svg";
export { ForwardRef as ReactComponent };